import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(private http: HttpClient) {}

  createCurrency(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/currency/create`, payload);
  }

  updateCurrency(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/currency/update`, payload);
  }

  getPagedCurrencies(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/currency/get-paged`, payload);
  }

  getAllActiveCurrencies(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/currency/get-all`);
  }
}
